"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
const core_services_1 = require("@iotv/core-services");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const ModelCommon_1 = require("./ModelCommon");
const commonSupportedTypes = ['Gateway', 'Device', 'User', 'Customer'].sort((a, b) => a.localeCompare(b));
const supportedTypes = Object.fromEntries([...commonSupportedTypes]
    .filter((x) => x)
    .map((type) => [type, type])
    .sort());
const typeName = 'Group';
class Group extends ModelCommon_1.ModelCommon {
    constructor({ supportedType, subSupportedType, domain, ...ob }) {
        super(ob.type ?? typeName, ob);
        this.supportedType = supportedType;
        this.subSupportedType = subSupportedType;
        this.domain = domain;
        this.metadata = ob.metadata ?? {};
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            supportedType: {
                type: this.supportedType ? (commonSupportedTypes.includes(this.supportedType) ? 'Enum' : 'String') : 'Enum',
                editable: !this.supportedType,
                required: true,
                displayFn: (supportedType) => (typeof supportedType === 'string' ? (0, core_services_1.readableTypeName)(supportedType) : undefined),
                enumKv: supportedTypes,
            },
        };
    }
    /** updates the {@link sk | child}'s {@link status | `status`} and re-evaluates the overall {@link Group | `Group`}'s status */
    updateStatusFromChild(sk, status) {
        if (!this.metadata)
            this.metadata = {};
        if (!this.metadata.children)
            this.metadata.children = {};
        this.metadata.children[sk] = status;
        this.metadata.status = Object.values(this.metadata.children)
            .filter(core_services_1.existsFilter)
            .every((status) => status === iotv_v3_types_1.MetaStatus.Normal)
            ? iotv_v3_types_1.MetaStatus.Normal
            : iotv_v3_types_1.MetaStatus.Abnormal;
        return this;
    }
}
exports.Group = Group;
